module.exports = __webpack_public_path__ + "img/icon2.160e0530.png";